export default __webpack_public_path__ + "static/media/scheepshelling.f16eddb7.svg";